
export default function BranchCard_dropdown({label, _class, action, _value, id, options}) {
  const deployOptions = ()=>{
    return options.map((opt, inx)=>{
      return <option key={`branchCard_id_${id}_option_${inx}`}>{opt}</option>
    })
  }
  return (
    <div dir='rtl' className={_class}>
        <label style={{fontWeight:"bold"}} htmlFor={id}>{label}</label>
        <select id={id} onChange={(e)=>{action(e)}} defaultValue={_value === true ? "פתוח" : _value === false ? "סגור" : _value}>
            {deployOptions()}
        </select>
    </div>
  )
}
